"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Creates batch of classes for provided attribute.
 * There will be separete class for each key/value pair that defined in styleSettings
 *
 * @param {String} attributeName
 * @theme {Object} styleSettings
 * @theme {Function} modifier - allows to modify generated styles
 */
const createStyles = (attributeName, styleSettings, modifier) => Object.keys(styleSettings).reduce((acc, slug) => {
  const styleObject = {
    [attributeName]: styleSettings[slug]
  };
  acc[`${attributeName}__${slug}`] = modifier ? modifier({
    styleObject
  }) : styleObject;
  return acc;
}, {});
var _default = exports.default = createStyles;